/* global clientGroupCategoriesUrl storeClientGroupCategoryUrl exportClientGroupUrl */
/* global canCreate canUpdate canDelete */
/* global venueDailyDemandIndexUrl venueDailyDemandUpsertUrl venueSportsIndexUrl venuesIndexUrl dailyDemandExportUrl */
/* global eventStartDate eventEndDate orgStartDate orgEndDate */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ClientGroupNumbersTable from './ClientGroupNumbersTable';
import VenuesDailyDemand from './venues_daily_demand/VenuesDailyDemand';

import Button from 'CommonComponents/Button';
import Tabs, { RenderStrategyOnVisit } from 'CommonComponents/Tabs';

import ExportIcon from 'Assets/icons/export.svg';

const CLIENT_GROUPS_NUMBERS = 'client-groups-numbers';
const VENUES_DAILY_DEMAND = 'venues-daily-demand';

export default function ClientGroupNumbers(props) {
    const tabs = [
        {
            id: CLIENT_GROUPS_NUMBERS,
            title: $t('Client Groups'),
            active: true,
            renderStrategy: RenderStrategyOnVisit,
            content: () => (
                <ClientGroupNumbersTable
                    clientGroupCategoriesUrl={props.clientGroupCategoriesUrl}
                    storeClientGroupCategoryUrl={props.storeClientGroupCategoryUrl}
                    canCreate={props.canCreate}
                    canUpdate={props.canUpdate}
                    canDelete={props.canDelete}
                />
            ),
        },
        {
            id: VENUES_DAILY_DEMAND,
            title: $t('Venues - Daily Demand'),
            renderStrategy: RenderStrategyOnVisit,
            content: () => (
                <VenuesDailyDemand
                    venueDailyDemandIndexUrl={venueDailyDemandIndexUrl}
                    venueDailyDemandUpsertUrl={venueDailyDemandUpsertUrl}
                    venueSportsIndexUrl={venueSportsIndexUrl}
                    venuesIndexUrl={venuesIndexUrl}
                    eventStartDate={eventStartDate}
                    eventEndDate={eventEndDate}
                    orgStartDate={orgStartDate}
                    orgEndDate={orgEndDate}
                />
            ),
        },
    ];

    const actions = [
        {
            for: CLIENT_GROUPS_NUMBERS,
            content: () => (
                <Button className="edit-locked-budget-entity" variant="primary" as="a" href={props.exportClientGroupUrl} data-action="navigate">
                    <ExportIcon className="tw-w-3 tw-h-3" />
                    {$t('Export to file')}
                </Button>
            ),
        },
        {
            for: VENUES_DAILY_DEMAND,
            content: () => (
                <Button variant="primary" as="a" href={props.dailyDemandExportUrl} data-action="navigate">
                    <ExportIcon className="tw-w-3 tw-h-3" />
                    {$t('Download')}
                </Button>
            ),
        },
    ];

    return <Tabs tabs={tabs} actions={actions} maxScreenHeight />;
}

if (document.getElementById('clientGroupNumbers')) {
    var rootEl = document.getElementById('clientGroupNumbers');
    ReactDOM.render(
        <App>
            <ClientGroupNumbers
                canCreate={canCreate}
                canUpdate={canUpdate}
                canDelete={canDelete}
                eventStartDate={eventStartDate}
                eventEndDate={eventEndDate}
                orgStartDate={orgStartDate}
                orgEndDate={orgEndDate}
                clientGroupCategoriesUrl={clientGroupCategoriesUrl}
                storeClientGroupCategoryUrl={storeClientGroupCategoryUrl}
                exportClientGroupUrl={exportClientGroupUrl}
                venueDailyDemandIndexUrl={venueDailyDemandIndexUrl}
                venueDailyDemandUpsertUrl={venueDailyDemandUpsertUrl}
                venueSportsIndexUrl={venueSportsIndexUrl}
                venuesIndexUrl={venuesIndexUrl}
                dailyDemandExportUrl={dailyDemandExportUrl}
            />
        </App>,
        rootEl,
    );
}
